import type { UpsellCohort } from '../useUpsellData';

export const hasAdvancedPlanner = (upsellCohort: UpsellCohort) => {
  return upsellCohort === 'paidUser' || upsellCohort === 'freeTrial';
};
